export const experienceData = [
  {
    id: 1,
    company: "Ciudadela",
    jobtitle: "Full-Stack Developer",
    startYear: "Jul 2022",
    endYear: "Present",
  },
  {
    id: 2,
    company: "Indra Systems",
    jobtitle: "Purchasing Category Manager",
    startYear: "Jul 2020",
    endYear: "May 2022",
  },
  {
    id: 3,
    company: "Airbus Operations",
    jobtitle: "Buyer",
    startYear: "Mar 2019",
    endYear: "Jul 2020",
  },
];
